import { render, staticRenderFns } from "./headline.vue?vue&type=template&id=2472f182"
import script from "./headline.vue?vue&type=script&lang=js"
export * from "./headline.vue?vue&type=script&lang=js"
import style0 from "./headline.vue?vue&type=style&index=0&id=2472f182&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports